import React from 'react';
import styled from 'styled-components';
import { ReactComponent as DownloadIcon } from 'assets/images/icons/download.svg';
import { InfoIcon as Info } from '@gr-monorepo/common/public/assets/icons';
import { SecondaryButton } from '@gr-monorepo/common/public/ui/Buttons';
import { LogClick } from 'features/shared/ClickStream';

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  margin-top: 24px;
`;

const InfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const InfoIconWrap = styled.div`
  flex-shrink: 0;
  line-height: 0;
  color: var(--black-60);

  svg {
    display: block;
    width: 16px;
    height: 16px;
  }
`;

const InfoText = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 20px;
  color: var(--black-60);
`;

const ExportButton = styled(SecondaryButton)`
  svg,
  svg path {
    fill: currentColor;
  }
`;

const DownloadReportButton = (props: {
  pendingReport?: boolean;
  onDownloadReport?: () => void;
  olympiadId: string;
  disabled: boolean;
}) => {
  const { pendingReport, onDownloadReport } = props;

  return (
    <Footer data-testid="download-report-footer">
      <InfoRow>
        <InfoIconWrap>
          <Info />
        </InfoIconWrap>
        <InfoText>
          Учитывается статистика с 1 класса. Чтобы посмотреть результаты по дошкольникам, обратитесь к менеджеру
        </InfoText>
      </InfoRow>
      <LogClick
        eventType="olymp_upload_to_excel"
        eventInfo="Олимпиада: Клик по кнопке Выгрузить в Excel"
        cd1={props.olympiadId}
      >
        <ExportButton
          type="button"
          size="medium"
          loading={pendingReport}
          disabled={pendingReport || props.disabled}
          onClick={onDownloadReport}
          data-testid="download-report-button"
        >
          {!pendingReport && <DownloadIcon />}
          {pendingReport ? 'Идет загрузка' : 'Выгрузить в Excel'}
        </ExportButton>
      </LogClick>
    </Footer>
  );
};

export default DownloadReportButton;
